import Vue from "vue";
import Vuex from "vuex";
import system from "./modules/system";
import user from "./modules/user";
import enums from "./modules/enums";
import assets from "./modules/assets";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    system,
    user,
    enums,
    assets
  }
});
